exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse[data-v-7b8b8efd] .ant-collapse {\n  border: 1px solid #eef7ff;\n}\n.collapse .collapse-item[data-v-7b8b8efd] {\n  padding: 10px;\n  margin: 4px;\n  cursor: pointer;\n}\n.collapse .collapse-item[data-v-7b8b8efd]:hover {\n  background-color: #eaf5ff;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.collapse .active[data-v-7b8b8efd] {\n  background-color: #eaf5ff;\n  border-radius: 4px;\n}\n", ""]);

// exports
